import { render, staticRenderFns } from "./stock-prod.vue?vue&type=template&id=650b6acd&scoped=true"
import script from "./stock-prod.vue?vue&type=script&lang=js"
export * from "./stock-prod.vue?vue&type=script&lang=js"
import style0 from "./stock-prod.vue?vue&type=style&index=0&id=650b6acd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b6acd",
  null
  
)

export default component.exports